import React, { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { Collapse } from 'reactstrap';
import { AdvancedCurrentPeopleFilterRoleUserApiComponent } from 'views/Widgets/Filters/AdvancedSpecializedFilter/highOrder';
import { type ApiGroup } from 'views/Widgets/Filters/AdvancedSpecializedFilter/types';

type Props = {
  value: ApiGroup | undefined;
};

// Toggle wording is fixed (matches Calibration's "View administration scope"
// exactly, regardless of owner/non-owner) so it's safe to resolve here with a
// static id/defaultMessage - unlike the "you can only add people within..."
// explanation text, which does vary by caller and has to be resolved there.
const AdminScopeDisclosure: FC<Props> = ({ value }) => {
  const { formatMessage } = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  // Once opened, stays mounted (even while visually collapsed) so
  // re-opening never re-fetches - only the very first open pays for the
  // suggestions request.
  const [hasOpened, setHasOpened] = useState(false);

  if (!value) return null;

  return (
    <>
      <button
        type="button"
        className="btn btn-link p-0 text-decoration-none d-inline-flex align-items-center gap-1"
        style={{ fontSize: 'inherit', lineHeight: 'inherit' }}
        onClick={() => {
          setIsOpen((prev) => !prev);
          setHasOpened(true);
        }}
      >
        <i className={`fe fe-chevron-${isOpen ? 'up' : 'down'}`} />
        {formatMessage({
          id: 'app.views.administration.custom_surveys.surveys.editor.admin_scope_toggle',
          defaultMessage: 'View administration scope',
        })}
      </button>
      <Collapse isOpen={isOpen}>
        {hasOpened && (
          <AdvancedCurrentPeopleFilterRoleUserApiComponent
            disabled={true}
            value={value}
          />
        )}
      </Collapse>
    </>
  );
};

export default React.memo(AdminScopeDisclosure);
